import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderMathQuestion = _resolveComponent("RenderMathQuestion")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-cursor-pointer", _ctx.buttonClass])
  }, [
    _createVNode(_component_RenderMathQuestion, {
      "question-kind": _ctx.format,
      question: _ctx.buttonData.label || _ctx.buttonData.value
    }, null, 8, ["question-kind", "question"])
  ], 2))
}